import React, { memo } from 'react';

interface Props {
	text: string;
	showTitle?: boolean;
}

function TextCell({ text, showTitle = true }: Props) {
	return <span title={showTitle ? text : null}>{text}</span>;
}

export default memo(TextCell);
